import React, { useState } from "react";
import IController from "@components/forms/IController";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

const FormPricePackage = (props) => {
  const [loading, setLoading] = useState(false);

  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      adult_price: props.tarif.item.adult_price,
      child_price: props.tarif.item.child_price,
      baby_price: props.tarif.item.baby_price,
      senior_price: props.tarif.item.senior_price,
      pax_available: props.tarif.item.pax_available,
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    props.tarif.item.adult_price = parseFloat(data.adult_price);
    props.tarif.item.child_price = parseFloat(data.child_price);
    props.tarif.item.baby_price = parseFloat(data.baby_price);
    props.tarif.item.senior_price = parseFloat(data.senior_price);
    props.tarif.item.pax_available = parseInt(data.pax_available);
    await props.changePrice(props.tarif, props.index, data);
    setLoading(false);
  };

  const rule = {
    type: "number",
    placeholder: props.t("adult_price"),
    messageError: props.t("price_is__required"),
    className: "input-blue text-dark w-100 p-3 border fw-light ",
    size: "md",
    rules: {
      required: props.t("mandatory"),
    },
  };
  const col = [6, 6, 6, 6, 12];

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          {[
            "adult_price",
            "child_price",
            "baby_price",
            "senior_price",
            "pax_available",
          ].map((field, index) => (
            <Col md={col[index]} key={field} style={{ marginBottom: "12px" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "12px",
                  fontWeight: "500",
                  marginBottom: 5,
                }}
              >
                {props.t(field.replace("_price", "")).toUpperCase()}
              </label>
              <IController
                elment={field}
                item={rule}
                control={control}
                errors={errors}
                register={register}
              />
            </Col>
          ))}
          <Col md="12" className="mt-3">
            <Form
              as="button"
              type="submit"
              className="btn-blue p-3 rounded-3 fw-bold w-100"
            >
              {loading ? (
                <Form
                  as="span"
                  className="spinner-border spinner-border-sm m-1 "
                ></Form>
              ) : (
                props.t("edit")
              )}
            </Form>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default FormPricePackage;
